export const NEW_WITH_DESIGN_ROUTE = '/new/with-design';
export const NEW_WITHOUT_DESIGN_ROUTE = '/new/without-design';

export const INTAKE_WITH_DESIGN_ROUTE = '/intake/with-design';
export const INTAKE_WITHOUT_DESIGN_ROUTE = '/intake/without-design';
